import React from "react";

function Motto() {
  return (
    <div className="motto-container">
      <div className="motto-text glow">Оновчтой шийдэл, бодит үр дүн</div>
    </div>
  );
}

export default Motto;